import { render, staticRenderFns } from "./WidgetAttributesTable.vue?vue&type=template&id=65fc52b9&"
import script from "./WidgetAttributesTable.vue?vue&type=script&lang=js&"
export * from "./WidgetAttributesTable.vue?vue&type=script&lang=js&"
import style0 from "./WidgetAttributesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports